import { NavLink } from "react-router-dom";
import { Anchor } from "lucide-react";

const links = [
  { to: "/",             label: "Explainer",     id: "nav-explainer" },
  { to: "/walkthrough",  label: "Walkthrough",   id: "nav-walkthrough" },
  { to: "/sandbox",      label: "Live sandbox",  id: "nav-sandbox" },
  { to: "/evidence",     label: "Evidence pack", id: "nav-evidence" },
  { to: "/script",       label: "Assessor script", id: "nav-script" },
];

export default function Nav() {
  return (
    <header className="border-b border-[var(--line)] bg-white sticky top-0 z-40" data-testid="top-nav">
      <div className="max-w-[1400px] mx-auto px-6 py-3 flex items-center justify-between">
        <NavLink to="/" className="flex items-center gap-3" data-testid="brand-link">
          <span className="w-8 h-8 grid place-items-center bg-[var(--navy)] text-white rounded-sm">
            <Anchor size={16} strokeWidth={2.2} />
          </span>
          <div className="leading-none">
            <div className="display text-[18px] tracking-tight">FreightCierge</div>
            <div className="mono text-[10px] uppercase tracking-[0.18em] text-[var(--ink-soft)] mt-0.5">
              Freight handoffs · Exceptions · Clearance evidence
            </div>
          </div>
        </NavLink>

        <nav className="flex items-center gap-1" data-testid="primary-nav">
          {links.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={l.id}
              className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-sm transition-colors ${
                  isActive
                    ? "bg-[var(--navy)] text-white"
                    : "text-[var(--ink)] hover:bg-[var(--paper)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="fc-tape" aria-hidden />
    </header>
  );
}
